var $73413cafa385c285$exports = {};
$73413cafa385c285$exports = {
    "breadcrumbs": `Breadcrumb`
};


export {$73413cafa385c285$exports as default};
//# sourceMappingURL=it-IT.mjs.map
